import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Button, FormControl } from 'react-bootstrap';
import { CustomerDropdown } from '../components/CustomerDropdown';
import { NotificationTypeDropdown } from '../components/NotificationTypeDropdown';
import { ClickReportGroup } from '../components/ClickReportGroup';

@inject('reportStore')
@observer
class NotificationEventsReport extends Component {
  displayName = NotificationEventsReport.name;

  state = {
    bouncesCollapsed: false,
    clicksCollapsed: false
  };

  toggleBounces = () => {
    this.setState({ bouncesCollapsed: !this.state.bouncesCollapsed });
  }

  toggleClicks = () => {
    this.setState({ clicksCollapsed: !this.state.clicksCollapsed });
  }

  componentDidMount() {
    this.props.reportStore.getCustomers();
    this.props.reportStore.getNotificationTypes();
  }

  setStartDate = (event) => {
    this.props.reportStore.setStartDate(event.target.value);
  }
  setEndDate = (event) => {
    this.props.reportStore.setEndDate(event.target.value);
  }
  render() {
    const { 
      customers, customerCode, setCustomerCode, generateReport, notificationEvents, 
      notificationTypes, notificationCode, setNotificationType, notificationEventsRequest
    } = this.props.reportStore;
    return (
      <div>
        <h1>Reports</h1>
        <hr></hr>
        <Form inline className='notifications-report-criteria'>
          <CustomerDropdown customers={customers} customerCode={customerCode} setCustomerCode={setCustomerCode} />
          <NotificationTypeDropdown notificationTypes={notificationTypes} notificationCode={notificationCode} setNotificationType={setNotificationType} />
          <FormControl type='date' onChange={this.setStartDate}/>
          <FormControl type='date' onChange={this.setEndDate}/>
          <Button bsStyle='primary' onClick={generateReport}>Search</Button>
        </Form>
        {
          notificationEventsRequest !== null && notificationEventsRequest.state === 'pending' ? 
            <div>...Loading...</div> : ''
        }
        <table className='notifications-report-table table mt-3'>
          <thead>
            <tr>
              <td>Date</td>
              <td># Sent</td>
              <td># Delivered</td>
              <td>Opens</td>
              <td>Unique Opens</td>
              <td>Clicks</td>
              <td>Bounces</td>
            </tr>
          </thead>
          <tbody>
            {
              Object.keys(notificationEvents.dayBreakdown).map(day => {
                const { sent, delivered, open, uniqueOpen, click, bounce, dropped } = notificationEvents.dayBreakdown[day];
                return (
                  <tr>
                    <td>{day}</td>
                    <td>{sent}</td>
                    <td>{delivered}</td>
                    <td>{open}</td>
                    <td>{uniqueOpen}</td>
                    <td>{click}</td>
                    <td>{bounce + dropped}</td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        <div>
        {
          notificationEvents.bounceReasons.length === 0 ? '' :
              <div>
                <h3 onClick={this.toggleBounces}>Bounces</h3>
                <table className='table' hidden={this.state.bouncesCollapsed}>
                <thead>
                  <tr>
                    <td>Date</td>
                    <td>Email</td>
                    <td>Reason</td>
                  </tr>
                </thead>
                <tbody>
                  {
                    notificationEvents.bounceReasons.map(reason => {
                      return (
                        <tr>
                          <td>{reason.date}</td>
                          <td>{reason.email}</td>
                          <td>{reason.reason}</td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            </div>
        }
        </div>
        <div>
          {
            notificationEvents.clicks.length === 0 ? '' :
              <div>
                <h3 onClick={this.toggleClicks}>Clicks</h3>
                <table className='table' hidden={this.state.clicksCollapsed}>
                  <thead>
                    <tr>
                      <td>Date</td>
                      <td>Email</td>
                      <td>Url</td>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      notificationEvents.clicks.map(reason => {
                        return (
                          <tr>
                            <td>{reason.date}</td>
                            <td>{reason.email}</td>
                            <td>{reason.url}</td>
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </div>
          }
        </div>
        <div>
          {
            notificationEvents.clickGroups.length === 0 ? '' :
              <div>
                <h3>Click Groups</h3>
                {
                  notificationEvents.clickGroups.map(group => {
                    return <ClickReportGroup items={group} />;
                  })
                }
              </div>
          }
        </div>
      </div>
    );
  }
}

export { NotificationEventsReport };